module.exports = __webpack_public_path__ + "img/banner-scholarship@2x.d718455f.jpg";